import React from 'react';
const aCommunityType = [
	{value:"Public Health",label:"Public Health"},
	{value:"Human Rights",label:"Human Rights"},
	{value:"Government",label:"Government"},
	{value:"NGO",label:"NGO"},
	{value:"SMARTCITIES",label:"SMARTCITIES"},
	{value:"HIV",label:"HIV"},
	{value:"TB",label:"TB"},
	{value:"DISASTER",label:"DISASTER"},
	{value:"Other",label:"Other"}
];

const aCommunityLanguages = [
		{value:"sq_AL" , label : "Albanian (Albania)"},
		{value:"ar_DZ" , label : "Arabic (Algeria)"},
		{value:"es_AR" , label : "Spanish (Argentina)"},
		{value:"en_AU" , label : "English (Australia)"},
		{value:"de_AT" , label : "German (Austria)"},
		{value:"ar_BH" , label : "Arabic (Bahrain)"},
		{value:"be_BY" , label : "Belarusian (Belarus)"},
		{value:"nl_BE" , label : "Dutch (Belgium)"},
		{value:"fr_BE" , label : "French (Belgium)"},
		{value:"es_BO" , label : "Spanish (Bolivia)"},
		{value:"sr_BA_#Latn" ,label : "Serbian (Latin,Bosnia and Herzegovina)"},
		{value:"sr_BA", label : "Serbian (Bosnia and Herzegovina)"},
		{value:"pt_BR", label : "Portuguese (Brazil)"},
		{value:"bg_BG", label : "Bulgarian (Bulgaria)"},
		{value:"en_CA", label : "English (Canada)"},
		{value:"fr_CA", label : "French (Canada)"},
		{value:"es_CL", label : "Spanish (Chile)"},
		{value:"zh_CN", label : "Chinese (China)"},
		{value:"es_CO", label : "Spanish (Colombia)"},
		{value:"es_CR", label : "Spanish (Costa Rica)"},
		{value:"hr_HR", label : "Croatian (Croatia)"},
		{value:"el_CY", label : "Greek (Cyprus)"},
		{value:"cs_CZ", label : "Czech (Czech Republic)"},
		{value:"da_DK", label : "Danish (Denmark)"},
		{value:"es_DO", label : "Spanish (Dominican Republic)"},
		{value:"es_EC", label : "Spanish (Ecuador)"},
		{value:"ar_EG", label : "Arabic (Egypt)"},
		{value:"es_SV", label : "Spanish (El Salvador)"},
		{value:"et_EE", label : "Estonian (Estonia)"},
		{value:"fi_FI", label : "Finnish (Finland)"},
		{value:"fr_FR", label : "French (France)"},
		{value:"de_DE", label : "German (Germany)"},
		{value:"el_GR", label : "Greek (Greece)"},
		{value:"es_GT", label : "Spanish (Guatemala)"},
		{value:"es_HN", label : "Spanish (Honduras)"},
		{value:"zh_HK", label : "Chinese (Hong Kong)"},
		{value:"hu_HU", label : "Hungarian (Hungary)"},
		{value:"is_IS", label : "Icelandic (Iceland)"},
		{value:"hi_IN", label : "Hindi (India)"},
		{value:"en_IN", label : "English (India)"},
		{value:"in_ID", label : "Indonesian (Indonesia)"},
		{value:"ar_IQ", label : "Arabic (Iraq)"},
		{value:"ga_IE", label : "Irish (Ireland)"},
		{value:"en_IE", label : "English (Ireland)"},
		{value:"iw_IL", label : "Hebrew (Israel)"},
		{value:"it_IT", label : "Italian (Italy)"},
		{value:"ja_JP_P_#u-ca-japanese", label : "Japanese (Japan,JP)"},
		{value:"ja_JP", label : "Japanese (Japan)"},
		{value:"ar_JO", label : "Arabic (Jordan)"},
		{value:"ar_KW", label : "Arabic (Kuwait)"},
		{value:"lv_LV", label : "Latvian (Latvia)"},
		{value:"ar_LB", label : "Arabic (Lebanon)"},
		{value:"ar_LY", label : "Arabic (Libya)"},
		{value:"lt_LT", label : "Lithuanian (Lithuania)"},
		{value:"fr_LU", label : "French (Luxembourg)"},
		{value:"de_LU", label : "German (Luxembourg)"},
		{value:"mk_MK", label : "Macedonian (Macedonia)"},
		{value:"ms_MY", label : "Malay (Malaysia)"},
		{value:"en_MT", label : "English (Malta)"},
		{value:"mt_MT", label : "Maltese (Malta)"},
		{value:"es_MX", label : "Spanish (Mexico)"},
		{value:"sr_ME_#Latn", label : "Serbian (Latin,Montenegro)"},
		{value:"sr_ME", label : "Serbian (Montenegro)"},
		{value:"ar_MA", label : "Arabic (Morocco)"},
		{value:"nl_NL", label : "Dutch (Netherlands)"},
		{value:"en_NZ", label : "English (New Zealand)"},
		{value:"es_NI", label : "Spanish (Nicaragua)"},
		{value:"no_NO", label : "Norwegian (Norway)"},
		{value:"no_NO_NY", label : "Norwegian (Norway,Nynorsk)"},
		{value:"ar_OM", label : "Arabic (Oman)"},
		{value:"es_PA", label : "Spanish (Panama)"},
		{value:"es_PY", label : "Spanish (Paraguay)"},
		{value:"es_PE", label : "Spanish (Peru)"},
		{value:"en_PH", label : "English (Philippines)"},
		{value:"pl_PL", label : "Polish (Poland)"},
		{value:"pt_PT", label : "Portuguese (Portugal)"},
		{value:"es_PR", label : "Spanish (Puerto Rico)"},
		{value:"ar_QA", label : "Arabic (Qatar)"},
		{value:"ro_RO", label : "Romanian (Romania)"},
		{value:"ru_RU", label : "Russian (Russia)"},
		{value:"ar_SA", label : "Arabic (Saudi Arabia)"},
		{value:"sr_RS", label : "Serbian (Serbia)"},
		{value:"sr_RS_#Latn", label : "Serbian (Latin,Serbia)"},
		{value:"sr_CS", label : "Serbian (Serbia and Montenegro)"},
		{value:"en_SG", label : "English (Singapore)"},
		{value:"zh_SG", label : "Chinese (Singapore)"},
		{value:"sk_SK", label : "Slovak (Slovakia)"},
		{value:"sl_SI", label : "Slovenian (Slovenia)"},
		{value:"en_ZA", label : "English (South Africa)"},
		{value:"ko_KR", label : "Korean (South Korea)"},
		{value:"es_ES", label : "Spanish (Spain)"},
		{value:"ca_ES", label : "Catalan (Spain)"},
		{value:"ar_SD", label : "Arabic (Sudan)"},
		{value:"sv_SE", label : "Swedish (Sweden)"},
		{value:"it_CH", label : "Italian (Switzerland)"},
		{value:"fr_CH", label : "French (Switzerland)"},
		{value:"de_CH", label : "German (Switzerland)"},
		{value:"ar_SY", label : "Arabic (Syria)"},
		{value:"zh_TW", label : "Chinese (Taiwan)"},
		{value:"th_TH", label : "Thai (Thailand)"},
		{value:"th_TH_H_#u-nu-thai", label : "Thai (Thailand,TH)"},
		{value:"ar_TN", label : "Arabic (Tunisia)"},
		{value:"tr_TR", label : "Turkish (Turkey)"},
		{value:"uk_UA", label : "Ukrainian (Ukraine)"},
		{value:"ar_AE", label : "Arabic (United Arab Emirates)"},
		{value:"en_GB", label : "English (United Kingdom)"},
		{value:"es_US", label : "Spanish (United States)"},
		{value:"en_US", label : "English (United States)"},
		{value:"es_UY", label : "Spanish (Uruguay)"},
		{value:"es_VE", label : "Spanish (Venezuela)"},
		{value:"vi_VN", label : "Vietnamese (Vietnam)"},
		{value:"ar_YE", label : "Arabic (Yemen)"},
]

const aCommCountries = [
	{value:"", label:"World"},
	{value:"Afghanistan", label : "Afghanistan"},
	{value:"Albania" , label : "Albania"},
	{value:"Algeria", label : "Algeria"},
	{value:"American Samoa",label : "American Samoa"},
	{value:"Andorra",label : "Andorra"},
	{value:"Angola",label : "Angola"},
	{value:"Anguilla",label:"Anguilla"},
	{value:"Antarctica",label:"Antarctica"},
	{value:"Antigua and Barbuda",label:"Antigua and Barbuda"},
	{value:"Argentina",label:"Argentina"},
	{value:"Armenia",label:"Armenia"},
	{value:"Aruba",label:"Aruba"},
	{value:"Australia",label:"Australia"},
	{value:"Austria",label:"Austria"},
	{value:"Azerbaijan",label:"Azerbaijan"},
	{value:"Bahamas",label:"Bahamas"},
	{value:"Bahrain",label:"Bahrain"},
	{value:"Bangladesh",label:"Bangladesh"},
	{value:"Barbados",label:"Barbados"},
	{value:"Belarus",label:"Belarus"},
	{value:"Belgium",label:"Belgium"},
	{value:"Belize",label:"Belize"},
	{value:"Benin",label:"Benin"},
	{value:"Bermuda",label:"Bermuda"},
	{value:"Bhutan",label:"Bhutan"},
	{value:"Bolivia",label:"Bolivia"},
	{value:"Bonaire, Sint Eustatius and Saba",label:"Bonaire, Sint Eustatius and Saba"},
	{value:"Bosnia and Herzegovina",label:"Bosnia and Herzegovina"},
	{value:"Botswana",label:"Botswana"},
	{value:"Bouvet Island",label:"Bouvet Island"},
	{value:"Brazil",label:"Brazil"},
	{value:"British Indian Ocean Territory",label:"British Indian Ocean Territory"},
	{value:"British Virgin Islands",label:"British Virgin Islands"},
	{value:"Brunei",label:"Brunei"},
	{value:"Bulgaria",label:"Bulgaria"},
	{value:"Burkina Faso",label:"Burkina Faso"},
	{value:"Burundi",label:"Burundi"},
	{value:"Cambodia",label:"Cambodia"},
	{value:"Cameroon",label:"Cameroon"},
	{value:"Canada",label:"Canada"},
	{value:"Cape Verde",label:"Cape Verde"},
	{value:"Cayman Islands",label:"Cayman Islands"},
	{value:"Central African Republic",label:"Central African Republic"},
	{value:"Chad",label:"Chad"},
	{value:"Chile",label:"Chile"},
	{value:"China",label:"China"},
	{value:"Christmas Island",label:"Christmas Island"},
	{value:"Cocos Islands",label:"Cocos Islands"},
	{value:"Colombia",label:"Colombia"},
	{value:"Comoros",label:"Comoros"},
	{value:"Congo",label:"Congo"},
	{value:"Cook Islands",label:"Cook Islands"},
	{value:"Costa Rica",label:"Costa Rica"},
	{value:"Croatia",label:"Croatia"},
	{value:"Cuba",label:"Cuba"},
	{value:"Curaçao",label:"Curaçao"},
	{value:"Cyprus",label:"Cyprus"},
	{value:"Czech Republic",label:"Czech Republic"},
	{value:"Côte d&#39;Ivoire",label:"Côte d'Ivoire"},
	{value:"Denmark",label:"Denmark"},
	{value:"Djibouti",label:"Djibouti"},
	{value:"Dominica",label:"Dominica"},
	{value:"Dominican Republic",label:"Dominican Republic"},
	{value:"Ecuador",label:"Ecuador"},
	{value:"Egypt",label:"Egypt"},
	{value:"El Salvador",label:"El Salvador"},
	{value:"Equatorial Guinea",label:"Equatorial Guinea"},
	{value:"Eritrea",label:"Eritrea"},
	{value:"Estonia",label:"Estonia"},
	{value:"Ethiopia",label:"Ethiopia"},
	{value:"Falkland Islands",label:"Falkland Islands"},
	{value:"Faroe Islands",label:"Faroe Islands"},
	{value:"Fiji",label:"Fiji"},
	{value:"Finland",label:"Finland"},
	{value:"France",label:"France"},
	{value:"French Guiana",label:"French Guiana"},
	{value:"French Polynesia",label:"French Polynesia"},
	{value:"French Southern Territories",label:"French Southern Territories"},
	{value:"Gabon",label:"Gabon"},
	{value:"Gambia",label:"Gambia"},
	{value:"Georgia",label:"Georgia"},
	{value:"Germany",label:"Germany"},
	{value:"Ghana",label:"Ghana"},
	{value:"Gibraltar",label:"Gibraltar"},
	{value:"Greece",label:"Greece"},
	{value:"Greenland",label:"Greenland"},
	{value:"Grenada",label:"Grenada"},
	{value:"Guadeloupe",label:"Guadeloupe"},
	{value:"Guam",label:"Guam"},
	{value:"Guatemala",label:"Guatemala"},
	{value:"Guernsey",label:"Guernsey"},
	{value:"Guinea",label:"Guinea"},
	{value:"Guinea-Bissau",label:"Guinea-Bissau"},
	{value:"Guyana",label:"Guyana"},
	{value:"Haiti",label:"Haiti"},
	{value:"Heard Island And McDonald Islands",label:"Heard Island And McDonald Islands"},
	{value:"Honduras",label:"Honduras"},
	{value:"Hong Kong",label:"Hong Kong"},
	{value:"Hungary",label:"Hungary"},
	{value:"Iceland",label:"Iceland"},
	{value:"India",label:"India"},
	{value:"Indonesia",label:"Indonesia"},
	{value:"Iran",label:"Iran"},
	{value:"Iraq",label:"Iraq"},
	{value:"Ireland",label:"Ireland"},
	{value:"Isle Of Man",label:"Isle Of Man"},
	{value:"Israel",label:"Israel"},
	{value:"Italy",label:"Italy"},
	{value:"Jamaica",label:"Jamaica"},
	{value:"Japan",label:"Japan"},
	{value:"Jersey",label:"Jersey"},
	{value:"Jordan",label:"Jordan"},
	{value:"Kazakhstan",label:"Kazakhstan"},
	{value:"Kenya",label:"Kenya"},
	{value:"Kiribati",label:"Kiribati"},
	{value:"Kuwait",label:"Kuwait"},
	{value:"Kyrgyzstan",label:"Kyrgyzstan"},
	{value:"Laos",label:"Laos"},
	{value:"Latvia",label:"Latvia"},
	{value:"Lebanon",label:"Lebanon"},
	{value:"Lesotho",label:"Lesotho"},
	{value:"Liberia",label:"Liberia"},
	{value:"Libya",label:"Libya"},
	{value:"Liechtenstein",label:"Liechtenstein"},
	{value:"Lithuania",label:"Lithuania"},
	{value:"Luxembourg",label:"Luxembourg"},
	{value:"Macao",label:"Macao"},
	{value:"Macedonia",label:"Macedonia"},
	{value:"Madagascar",label:"Madagascar"},
	{value:"Malawi",label:"Malawi"},
	{value:"Malaysia",label:"Malaysia"},
	{value:"Maldives",label:"Maldives"},
	{value:"Mali",label:"Mali"},
	{value:"Malta",label:"Malta"},
	{value:"Marshall Islands",label:"Marshall Islands"},
	{value:"Martinique",label:"Martinique"},
	{value:"Mauritania",label:"Mauritania"},
	{value:"Mauritius",label:"Mauritius"},
	{value:"Mayotte",label:"Mayotte"},
	{value:"Mexico",label:"Mexico"},
	{value:"Micronesia",label:"Micronesia"},
	{value:"Moldova",label:"Moldova"},
	{value:"Monaco",label:"Monaco"},
	{value:"Mongolia",label:"Mongolia"},
	{value:"Montenegro",label:"Montenegro"},
	{value:"Montserrat",label:"Montserrat"},
	{value:"Morocco",label:"Morocco"},
	{value:"Mozambique",label:"Mozambique"},
	{value:"Myanmar",label:"Myanmar"},
	{value:"Namibia",label:"Namibia"},
	{value:"Nauru",label:"Nauru"},
	{value:"Nepal",label:"Nepal"},
	{value:"Netherlands",label:"Netherlands"},
	{value:"Netherlands Antilles",label:"Netherlands Antilles"},
	{value:"New Caledonia",label:"New Caledonia"},
	{value:"New Zealand",label:"New Zealand"},
	{value:"Nicaragua",label:"Nicaragua"},
	{value:"Niger",label:"Niger"},
	{value:"Nigeria",label:"Nigeria"},
	{value:"Niue",label:"Niue"},
	{value:"Norfolk Island",label:"Norfolk Island"},
	{value:"North Korea",label:"North Korea"},
	{value:"Northern Mariana Islands",label:"Northern Mariana Islands"},
	{value:"Norway",label:"Norway"},
	{value:"Oman",label:"Oman"},
	{value:"Pakistan",label:"Pakistan"},
	{value:"Palau",label:"Palau"},
	{value:"Palestine",label:"Palestine"},
	{value:"Panama",label:"Panama"},
	{value:"Papua New Guinea",label:"Papua New Guinea"},
	{value:"Paraguay",label:"Paraguay"},
	{value:"Peru",label:"Peru"},
	{value:"Philippines",label:"Philippines"},
	{value:"Pitcairn",label:"Pitcairn"},
	{value:"Poland",label:"Poland"},
	{value:"Portugal",label:"Portugal"},
	{value:"Puerto Rico",label:"Puerto Rico"},
	{value:"Qatar",label:"Qatar"},
	{value:"Reunion",label:"Reunion"},
	{value:"Romania",label:"Romania"},
	{value:"Russia",label:"Russia"},
	{value:"Rwanda",label:"Rwanda"},
	{value:"Saint Barthélemy",label:"Saint Barthélemy"},
	{value:"Saint Helena",label:"Saint Helena"},
	{value:"Saint Kitts And Nevis",label:"Saint Kitts And Nevis"},
	{value:"Saint Lucia",label:"Saint Lucia"},
	{value:"Saint Martin",label:"Saint Martin"},
	{value:"Saint Pierre And Miquelon",label:"Saint Pierre And Miquelon"},
	{value:"Saint Vincent And The Grenadines",label:"Saint Vincent And The Grenadines"},
	{value:"Samoa",label:"Samoa"},
	{value:"San Marino",label:"San Marino"},
	{value:"Sao Tome And Principe",label:"Sao Tome And Principe"},
	{value:"Saudi Arabia",label:"Saudi Arabia"},
	{value:"Senegal",label:"Senegal"},
	{value:"Serbia",label:"Serbia"},
	{value:"Serbia and Montenegro",label:"Serbia and Montenegro"},
	{value:"Seychelles",label:"Seychelles"},
	{value:"Sierra Leone",label:"Sierra Leone"},
	{value:"Singapore",label:"Singapore"},
	{value:"Sint Maarten (Dutch part)",label:"Sint Maarten (Dutch part"},
	{value:"Slovakia",label:"Slovakia"},
	{value:"Slovenia",label:"Slovenia"},
	{value:"Solomon Islands",label:"Solomon Islands"},
	{value:"Somalia",label:"Somalia"},
	{value:"South Africa",label:"South Africa"},
	{value:"South Georgia And The South Sandwich Islands",label:"South Georgia And The South Sandwich Islands"},
	{value:"South Korea",label:"South Korea"},
	{value:"Spain",label:"Spain"},
	{value:"Sri Lanka",label:"Sri Lanka"},
	{value:"Sudan",label:"Sudan"},
	{value:"Suriname",label:"Suriname"},
	{value:"Svalbard And Jan Mayen",label:"Svalbard And Jan Mayen"},
	{value:"Swaziland",label:"Swaziland"},
	{value:"Sweden",label:"Sweden"},
	{value:"Switzerland",label:"Switzerland"},
	{value:"Syria",label:"Syria"},
	{value:"Taiwan",label:"Taiwan"},
	{value:"Tajikistan",label:"Tajikistan"},
	{value:"Tanzania",label:"Tanzania"},
	{value:"Thailand",label:"Thailand"},
	{value:"The Democratic Republic Of Congo",label:"The Democratic Republic Of Congo"},
	{value:"Timor-Leste",label:"Timor-Leste"},
	{value:"Togo",label:"Togo"},
	{value:"Tokelau",label:"Tokelau"},
	{value:"Tonga",label:"Tonga"},
	{value:"Trinidad and Tobago",label:"Trinidad and Tobago"},
	{value:"Tunisia",label:"Tunisia"},
	{value:"Turkey",label:"Turkey"},
	{value:"Turkmenistan",label:"Turkmenistan"},
	{value:"Turks And Caicos Islands",label:"Turks And Caicos Islands"},
	{value:"Tuvalu",label:"Tuvalu"},
	{value:"U.S. Virgin Islands",label:"U.S. Virgin Islands"},
	{value:"Uganda",label:"Uganda"},
	{value:"Ukraine",label:"Ukraine"},
	{value:"United Arab Emirates",label:"United Arab Emirates"},
	{value:"United Kingdom",label:"United Kingdom"},
	{value:"United States",label:"United States"},
	{value:"United States Minor Outlying Islands",label:"United States Minor Outlying Islands"},
	{value:"Uruguay",label:"Uruguay"},
	{value:"Uzbekistan",label:"Uzbekistan"},
	{value:"Vanuatu",label:"Vanuatu"},
	{value:"Vatican",label:"Vatican"},
	{value:"Venezuela",label:"Venezuela"},
	{value:"Vietnam",label:"Vietnam"},
	{value:"Wallis And Futuna",label:"Wallis And Futuna"},
	{value:"Western Sahara",label:"Western Sahara"},
	{value:"Yemen",label:"Yemen"},
	{value:"Zambia",label:"Zambia"},
	{value:"Zimbabwe",label:"Zimbabwe"},
	{value:"Åland Islands",label:"Åland Islands"},
]

const aCommunitySections = [
	{value:"Dashboard",label:"Dashboard"},
	{value:"Inbox",label:"Inbox"},
	{value:"Maps",label:"Maps"},	
	{value:"Analysis",label:"Analysis"},
	{value:"Charts",label:"Charts"},
	{value:"Users",label:"Users"},
	{value:"Translation",label:"Translation"},
	{value:"Pages",label:"Pages"}
];

const aServiceType = [
	{value:"Non-Linked",label:"Non-Linked"}/*,
	{value:"Linked",label:"Linked"}*/
];

const nearmeType = [
	{value:"hospital", label:"Hospital"},
	{value:"blood_bank", label:"Blood Bank"},
	{value:"ALLIANCE_ART", label:"ALLIANCE ART"},
	{value:"Health_Facility", label:"Health Facility"},
	{value:"dengue_centers", label:"Dengue Centers"},
	{value:"police_stations", label:"Police Stations"},
	{value:"fire_stations", label:"Fire Stations"},
	{value:"bank", label:"Bank"},
	{value:"NGO", label:"NGO"},
	{value:"Businesses", label:"Businesses"},
	{value:"wheel_chair_friendly_locations", label:"Wheel Chair Friendly Locations"},
	{value:"Individuals_and_Families", label:"Individuals and Families"},	
	{value:"insurance_agency", label:"Insurance Agency"},
	{value:"jewelry_store", label:"Jewelry Store"},
	{value:"laundry", label:"Laundry"},
	{value:"lawyer", label:"Lawyer"},
	{value:"library", label:"Library"},
	{value:"others", label:"Others"},                                                    
];


const aQuestionType = [
	/*{value:"", label:"Please Select Type"},*/
	{value:"Text", label:"Text"},
	{value:"Number", label:"Number"},
	{value:"Date", label:"Date"},
	{value:"Dropdown", label:"Dropdown"},
	{value:"Radio", label:"Radio"},
	{value:"Checkbox", label:"Checkbox"}	
];

const aUserType = [
	{value:"USER", label:"USER"},	
	{value:"VOLUNTEER", label:"VOLUNTEER"}	
];

const dashboardUserType = [
	{value:"ADMIN", label:"ADMIN"},	
	{value:"COMMUNITY-RESPONDER", label:"COMMUNITY RESPONDER"},
	{value:"COMMUNITY-PROFILER", label:"COMMUNITY PROFILER"}
];

const aMobileSections = [
	{value:"Information",label:"Information"},
	{value:"Services",label:"Services"},
	{value:"Survey",label:"Survey"},
	{value:"Nearme",label:"Nearme"},
	{value:"Reminder",label:"Reminder"},
	{value:"Peerchat",label:"Peer chat"}
];


const templateType = [
	{value:"List",label:"List"},
	{value:"Card",label:"Card"},
	{value:"Sidebar",label:"Sidebar"}		
];

const aLoginTour = [
	{
	    selector: '.btn-register-community',
	    content: 'Register for your community',
  	},
  	{
	    selector: '[name="email"]',
	    content: 'Enter email you provided for registration',
  	},
  	{
	    selector: '[name="password"]',
	    content: 'Enter password you recieved',
  	}
];

const aRegisterTour = [
	{
	    selector: '[name="name"]',
	    content: 'Enter community name',
  	},
  	{
	    selector: '[name="email"]',
	    content: 'Enter community email',
  	},
  	{
	    selector: '[type="submit"]',
	    content: 'Submit to register community',
  	}
];

const aCommunitySetUpTour = [
	{
	    selector: '#appconfig-tab',
	    content: (e) => (
	    	<div className="container-fluid">
	    		<div className="col-xs-12">
	    			Pre requisite for dashboard configuation
	    		</div>
	    	</div>
    	),
  	},
  	{
	    selector: '#home-tab',
	    content: () => (
		    	<div className="container-fluid">
	    			<dl className="row">
					  	<dt className="col-sm-3">Community Information</dt>
					  	<dd className="col-sm-9">
					  		<p>Add/Edit Community Name, Community Type, Project Name and Summary</p>
					  	</dd>

					  	<dt className="col-sm-3">Community Language(s)</dt>
					  	<dd className="col-sm-9">
						    <p>English will be default community language</p>
						    <p>Add/Remove community languages</p>
					  	</dd>

					 	<dt className="col-sm-3">Map View</dt>
					  	<dd className="col-sm-9">
					  		Add Region specific map view
					  	</dd>

					 	<dt className="col-sm-3 text-truncate">Logo</dt>
				  		<dd className="col-sm-9">
				  			Add/Change logo and Featured image
				  		</dd>

					  	<dt className="col-sm-3">Dashboard Sections</dt>
					  	<dd className="col-sm-9">
						    Add/Remove required dashboard sections
					  	</dd>
					</dl>
		    	</div>
    	),
	    style:{
      		maxWidth:"500px"
	    }
  	},
  	{
	    selector: '#getknowlegeable-tab',
	    content: 'Add/Edit Multilingual information with media',
  	},
  	{
	    selector: '#service-tab',
	    content: () => (
			<div className="container-fluid">
    			<dl className="row">
	    			<dt className="col-sm-3">Adding Services</dt>
				  	<dd className="col-sm-9">
				    	<p>Add/Edit/Delete Linked or non-Linked services</p>
				    	<p>Add/Edit/Delete Questions for individual services</p>
				    	<p>Manage dependencies of questions</p>
				  	</dd>

	    			<dt className="col-sm-3">Adding Surveys</dt>
				  	<dd className="col-sm-9">
				    	<p>Add/Edit/Delete Linked or non-Linked Surveys</p>
				    	<p>Add/Edit/Delete Questions for individual Surveys</p>
				    	<p>Manage dependencies of survey questions</p>
				  	</dd>
	    		</dl>
	    	</div>
    	)
  	},
  	{
	    selector: '#nearme-tab',
	    content: () => (
	    	<div className="container-fluid">
    			<dl className="row">
	    			<dt className="col-sm-3">Adding Nearme</dt>
				  	<dd className="col-sm-9">
				    	<p>Add Nearme with details</p>
				  	</dd>

	    			<dt className="col-sm-3">Nearme List</dt>
				  	<dd className="col-sm-9">
				    	<p>Listing of nearme</p>
				    	<p>Edit/Deactivate listed nearme</p>
				  	</dd>

	    			<dt className="col-sm-3">Nearme Upload</dt>
				  	<dd className="col-sm-9">
				    	<p>Drag and drop file for Neame Bulk Upload</p>
				  	</dd>
	    		</dl>
	    	</div>
	    )
  	},
  	{
	    selector: '#finish-tab',
	    content: () => (
	    	<div className="container-fluid">
    			<dl className="row">
	    			<dt className="col-sm-3">Mobile Sections</dt>
				  	<dd className="col-sm-9">
				    	<p>Add Sections needed to be shown in mobile app</p>
				    	<p>Add Template Type for mobile app</p>
				  	</dd>

	    			<dt className="col-sm-3">Scocial media</dt>
				  	<dd className="col-sm-9">
				    	<p>Add Facebook and Twitter Links</p>
				  	</dd>

	    			<dt className="col-sm-3">Store Links</dt>
				  	<dd className="col-sm-9">
				    	<p>Add Playstore and app store links</p>
				  	</dd>
	    		</dl>
	    	</div>
	    )
  	}
];

export {
  	aCommunityType,
  	aCommunityLanguages,
  	aCommCountries,
	aCommunitySections,
  	aServiceType,
	nearmeType,
	aQuestionType,
  	aUserType,
	aMobileSections,
	dashboardUserType,
	templateType,
	aLoginTour,
	aRegisterTour,
	aCommunitySetUpTour
};

